import { gql } from "@apollo/client"
import { ReconfirmMandateLodgingInput, ReconfirmMandateLodgingPayload } from "@oysterhr/schema"
import { InjectedOptions, useMutation } from "@oysterhr/core"

type Response = {
  reconfirmMandateLodging: ReconfirmMandateLodgingPayload
}

export const RECONFIRM_MANDATE_LODGING = gql`
  mutation ReconfirmMandateLodging($mandateId: ID!) {
    reconfirmMandateLodging(input: { mandateId: $mandateId }) {
      mandate {
        state
        signedDownloadUrl {
          url
        }
      }
      errors
    }
  }
`

export const useReconfirmMandateLodging = (
  options?: InjectedOptions<Response, ReconfirmMandateLodgingInput>,
) => useMutation<Response, ReconfirmMandateLodgingInput>(RECONFIRM_MANDATE_LODGING, options)
